import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonAnonymous16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPersonAnonymous16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.667 7.494a3 3 0 0 1-1.167.464V8.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 8 7h.029a2 2 0 1 0-2.03-2H5a3 3 0 1 1 4.667 2.494m2.583 4.256c0-1.47-.746-2.765-1.88-3.528q.414-.305.738-.704a5.24 5.24 0 0 1 2.142 4.232V14H2.75v-2.25c0-1.736.843-3.276 2.142-4.232q.324.4.737.704A4.25 4.25 0 0 0 3.75 11.75V13h8.5zM8 12a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1a.5.5 0 0 0 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonAnonymous16);
